import { InfoPopupImage } from './ImageContainers';
import { nodeColorFunction } from '../utils/colorUtils';
import Visualizations from './Visualizations';

export default function NodeInfoPopup({ selectedNode, closePopup, isDarkMode, colorKey, otherCommentNodes, showAllNodes, allNodes }) {
  if (!selectedNode && !showAllNodes) return null; // Render nothing if no node is selected and showAllNodes is false

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)',
        color: isDarkMode ? 'white' : 'black',
        zIndex: 1000,
      }}
      onClick={closePopup}
    >
      <div
        style={{
          margin: '2rem',
          width: 'auto',
          height: '90%',
          overflow: 'scroll',
          overflowX: 'hidden',
          border: '1rem solid var(--menu-border-color-opposite)',
          borderRadius: '1rem',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div
          className="popup-container"
          style={{
            backgroundColor: isDarkMode ? '#333' : '#fff',
            color: isDarkMode ? 'white' : 'black',
            overflowX: 'hidden',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Add a close button */}
          <button
            onClick={closePopup}
            style={{
              position: 'absolute',
              top: '2rem',
              right: '2rem',
              background: 'var(--menu-border-color)',
              border: '1rem solid var(--menu-border-color-opposite)',
              borderRadius: '0 1rem 0 1rem',
              fontSize: '1.5rem',
              color: 'var(--menu-border-color-opposite)',
              cursor: 'pointer',
            }}
          >
            X
          </button>
          <h1 style={{ margin: '0', padding: '1rem' }}>{showAllNodes ? 'All Nodes' : 'Node Information'}</h1>

          {showAllNodes ? (
            <div style={{ padding: '1rem' }}>
              <Visualizations selectedNode={null} otherCommentNodes={otherCommentNodes || allNodes} isDarkMode={isDarkMode} />
            </div>
          ) : selectedNode ? (
            <div style={{ padding: '1rem' }}>
              <div
                style={{
                  width: '2rem',
                  height: '2rem',
                  borderRadius: '50%',
                  backgroundColor: nodeColorFunction(colorKey)(selectedNode),
                  display: 'inline-block',
                  marginRight: '0.5rem',
                }}
              ></div>
              {selectedNode.id && <p><strong>ID:<br /></strong> {selectedNode.id}</p>}
              {selectedNode.name && <p><strong>Name:<br /></strong> {selectedNode.name}</p>}
              {selectedNode.description && (
                <p>
                  <strong>Description:<br /></strong>
                  {selectedNode.description.split('\n').map((line, index) => (
                    <span key={index}>{line}</span>
                  ))}
                </p>
              )}
              {selectedNode.date && <p><strong>Date:<br /></strong> {selectedNode.date}</p>}
              {selectedNode.weights && (
                <p>
                  <strong>Weights:<br /></strong>
                  {typeof selectedNode.weights === 'string'
                    ? selectedNode.weights
                    : Object.entries(selectedNode.weights).map(([key, value]) => (
                      <span key={key}>
                        <i>{key}</i> <br />
                        {typeof value === 'string'
                          ? value
                          : Object.entries(value)
                            .map(([subKey, subValue]) => `${subKey}: ${subValue}`)
                            .join(' | ')}
                        <br />
                      </span>
                    ))}
                </p>
              )}
              {selectedNode.url && (
                <p>
                  <strong>Link: </strong>{' '}
                  <a href={selectedNode.url} target="_blank" rel="noopener noreferrer">
                    {selectedNode.url}
                  </a>
                </p>
              )}
              {selectedNode.tags && (
                <div>
                  <strong>Tags: </strong>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '0.5rem',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0.5rem 0',
                    }}
                  >
                    {selectedNode.tags.map((tag, index) => (
                      <span
                        key={index}
                        style={{
                          padding: '0.2rem 0.5rem',
                          backgroundColor: 'var(--menu-border-color)',
                          borderRadius: '5px',
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {selectedNode.image_url && (
                <div
                  style={{
                    marginTop: '1rem',
                    // border: '1px solid var(--menu-border-color)',
                    borderRadius: '10px',
                    padding: '1rem',
                  }}
                >
                  <h3>The Post</h3>
                  {selectedNode.post_url && (
                    <a
                      href={selectedNode.post_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: 'var(--menu-border-color-opposite)' }}
                    >
                      <p
                        style={{
                          backgroundColor: 'var(--menu-border-color)',
                          padding: '0.5rem',
                          borderRadius: '5px',
                        }}
                      >
                        Link to Post on Flickr
                      </p>
                    </a>
                  )}
                  {selectedNode.image_url && <InfoPopupImage selectedNode={selectedNode} />}

                  {/* Visualizations */}
                  <Visualizations selectedNode={selectedNode} otherCommentNodes={otherCommentNodes} isDarkMode={isDarkMode} />

                  {/* Display other comment nodes */}
                  {otherCommentNodes && otherCommentNodes.length > 0 && (
                    <div style={{ marginTop: '1rem' }}>
                      <h3>Other Comments ({otherCommentNodes.length})</h3>
                      <ul style={{ padding: '0' }}>
                        {otherCommentNodes.map((node, index) => (
                          <li
                            key={index}
                            style={{
                              lineHeight: '1.5rem',
                              listStyleType: 'none',
                              display: 'grid',
                              gridTemplateColumns: '1rem 1fr',
                              alignItems: 'center',
                              gap: '0.5rem',
                              padding: '0.5rem',
                              marginBottom: '0.5rem',
                              border: '1px solid var(--menu-border-color)',
                              borderRadius: '10px',
                            }}
                          >
                            <div
                              style={{
                                width: '1rem',
                                height: '1rem',
                                borderRadius: '50%',
                                backgroundColor: nodeColorFunction(colorKey)(node),
                                display: 'inline-block',
                              }}
                            ></div>
                            {node.description}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <p>No node selected</p>
          )}
        </div>
      </div>
    </div>
  );
}
